module.exports = __webpack_public_path__ + "img/process_icon.e587668f.svg";